(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sibling-swatches"] && !Shopify.designMode) return;
  try {
    class ProductSiblingSwatches extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick);
      this.syncQuickAddState();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick = (event) => {
      const swatch = event.target.closest('[data-sibling-swatch]');

      if (!swatch || !this.contains(swatch)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      this.selectSwatch(swatch);
    };

    syncQuickAddState() {
      if (!window.__lunaSiblingQuickAddSync) {
        return;
      }

      const productCard = this.closest('product-card');
      const quickAdd = productCard?.querySelector('quick-add-component');

      if (!quickAdd) {
        return;
      }

      quickAdd.setAttribute('data-quick-add-button', 'choose');
      quickAdd.setAttribute('data-product-options-count', '2');
      quickAdd.setAttribute('data-has-sibling-variations', 'true');
    }

    parseSiblingMedia(swatch) {
      try {
        const media = JSON.parse(swatch.dataset.siblingMedia || '[]');

        if (Array.isArray(media)) {
          return media.filter((item) => item?.src);
        }
      } catch (error) {
        console.warn('Could not parse sibling product media', error);
      }

      return [];
    }

    createGallerySlide(media, index, title) {
      const slide = document.createElement('slideshow-slide');
      const slideId = media.id || `sibling-media-${index}`;
      const mediaType = media.mediaType || 'image';

      slide.setAttribute('ref', 'slides[]');
      slide.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
      slide.setAttribute('slide-id', slideId);
      slide.className = `product-media-container media-fit product-media-container--${mediaType}`;
      slide.style.setProperty('--slideshow-timeline', `--slide-${index}`);
      slide.style.setProperty('--product-media-fit', 'cover');
      slide.style.setProperty('--grid-template-rows', '50dvh 1fr');
      slide.style.setProperty('--grid-template-rows-desktop', '70dvh 1fr');

      const productMedia = document.createElement('div');
      productMedia.className = 'product-media';
      productMedia.dataset.mediaId = slideId;
      productMedia.style.setProperty('--ratio', media.ratio || '1');

      const image = document.createElement('img');
      image.className = 'product-media__image';
      image.src = media.src;
      image.srcset = media.srcset || '';
      image.sizes = 'auto, (min-width: 750px) 50vw, 100vw';
      image.alt = media.alt || title || '';
      image.loading = index === 0 ? 'eager' : 'lazy';

      if (media.width) {
        image.width = Number(media.width);
      }

      if (media.height) {
        image.height = Number(media.height);
      }

      if (media.focalPoint) {
        image.style.setProperty('--focal-point', media.focalPoint);
      }

      if (media.transitionToProduct) {
        image.setAttribute('transitionToProduct', 'true');
      }

      productMedia.append(image);
      slide.append(productMedia);

      return slide;
    }

    syncGalleryArrows(slideshow, mediaCount) {
      const isDisabled = slideshow.getAttribute('disabled') === 'true';
      const existingArrows = slideshow.querySelector('slideshow-arrows');

      if (mediaCount <= 1 || isDisabled) {
        if (existingArrows) {
          existingArrows.hidden = true;
        }

        return;
      }

      if (existingArrows) {
        existingArrows.hidden = false;
        return;
      }

      const arrowsTemplate = this.querySelector('[data-sibling-gallery-arrows-template]');
      const slideshowContainer = slideshow.querySelector('slideshow-container');
      const slidesContainer = slideshow.querySelector('slideshow-slides');

      if (arrowsTemplate && slideshowContainer && slidesContainer) {
        slidesContainer.before(arrowsTemplate.content.cloneNode(true));
      }
    }

    updateGalleryMedia(productCard, swatch, title) {
      const mediaItems = this.parseSiblingMedia(swatch);
      const cardGallery = productCard.querySelector('[ref="cardGallery"]');
      const slideshow = cardGallery?.querySelector('slideshow-component');
      const slidesContainer = slideshow?.querySelector('slideshow-slides');

      if (!cardGallery || !slideshow || !slidesContainer || !mediaItems.length) {
        return false;
      }

      const nextSlideshow = slideshow.cloneNode(true);
      const nextSlidesContainer = nextSlideshow.querySelector('slideshow-slides');

      if (!nextSlidesContainer) {
        return false;
      }

      const timeline = mediaItems.map((_, index) => `--slide-${index}`).join(',');
      nextSlidesContainer.replaceChildren(...mediaItems.map((media, index) => this.createGallerySlide(media, index, title)));
      nextSlideshow.setAttribute('initial-slide', '0');
      nextSlideshow.setAttribute('data-generic-media-size', `${mediaItems.length}`);
      nextSlideshow.style.setProperty('--slideshow-timeline', timeline);
      this.syncGalleryArrows(nextSlideshow, mediaItems.length);

      slideshow.replaceWith(nextSlideshow);

      requestAnimationFrame(() => {
        const activeSlideshow = cardGallery.querySelector('slideshow-component');
        activeSlideshow?.select?.(0, undefined, { animate: false });
      });

      return true;
    }

    updateFallbackGalleryImage(productCard, cardImage, srcset, title) {
      const activeImage =
        productCard.querySelector('[ref="cardGallery"] slideshow-slide[aria-hidden="false"] img') ||
        productCard.querySelector('[ref="cardGallery"] img');

      if (!activeImage || !cardImage) {
        return;
      }

      activeImage.src = cardImage;

      if (srcset) {
        activeImage.srcset = srcset;
      }

      if (title) {
        activeImage.alt = title;
      }
    }

    selectSwatch(swatch) {
      const productCard = this.closest('product-card');

      if (!productCard) {
        return;
      }

      const url = swatch.dataset.siblingUrl;
      const title = swatch.dataset.siblingTitle;
      const label = swatch.dataset.siblingLabel;
      const cardImage = swatch.dataset.siblingImage;
      const featuredImage = swatch.dataset.siblingFeaturedImage || cardImage;
      const srcset = swatch.dataset.siblingSrcset;

      this.querySelectorAll('[data-sibling-swatch]').forEach((button) => {
        const isSelected = button === swatch;
        button.classList.toggle('sibling-swatches__button--selected', isSelected);
        button.toggleAttribute('data-selected', isSelected);
        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      const selectedLabel = this.querySelector('[data-sibling-selected-label]');

      if (selectedLabel && label) {
        selectedLabel.textContent = label;
      }

      if (url) {
        productCard.querySelectorAll('[ref="productCardLink"], [ref="cardGalleryLink"], [ref="productTitleLink"]').forEach((link) => {
          link.setAttribute('href', url);
        });
      }

      const cardLink = productCard.closest('product-card-link');

      if (cardLink) {
        if (swatch.dataset.siblingProductId) {
          cardLink.setAttribute('data-product-id', swatch.dataset.siblingProductId);
        }

        if (featuredImage) {
          cardLink.setAttribute('data-featured-media-url', featuredImage);
        }
      }

      const cardGallery = productCard.querySelector('[ref="cardGallery"]');

      if (cardGallery && swatch.dataset.siblingProductId) {
        cardGallery.setAttribute('data-product-id', swatch.dataset.siblingProductId);
      }

      const galleryUpdated = this.updateGalleryMedia(productCard, swatch, title);

      if (!galleryUpdated && cardImage) {
        this.updateFallbackGalleryImage(productCard, cardImage, srcset, title);
      } else if (cardGallery && title) {
        const titlePlaceholder = cardGallery.querySelector('[ref="productTitleLink"]');

        if (titlePlaceholder) {
          titlePlaceholder.setAttribute('aria-label', title);
        }
      }

      this.syncQuickAddState();

      if (window.__lunaSiblingQuickAddSync && title) {
        const quickAdd = productCard.querySelector('quick-add-component');

        if (quickAdd) {
          quickAdd.setAttribute('data-product-title', title);
        }
      }
    }
  }

  if (!customElements.get('product-sibling-swatches')) {
    customElements.define('product-sibling-swatches', ProductSiblingSwatches);
  }
  } catch(e) { console.error(e); }
})();

})();
